// extracted by mini-css-extract-plugin
export default {"login-registration-modal__footer":"login-registration-modal__footer_CwATD6iY","login-registration-modal__text":"login-registration-modal__text_hMYWC4PD"};